import styled from 'styled-components';

export const ModalWrapper = styled.div`
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-height: calc(100vh - 80px);
    max-height: calc(100dvh - 80px);
    overflow-y: auto;
    padding: 16px 16px 40px;
    border-radius: 8px 8px 0 0;
    background: #fff;
    color: #151514;
    font-family: Inter, sans-serif;
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const ModalText = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
`;

export const Title = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;

export const Subtitle = styled.div`
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: -0.02em;
`;

export const CloseButton = styled.button`
    display: flex;
    flex: 0 0 24px;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
`;

export const ModalButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const PublishButton = styled.button`
    box-sizing: border-box;
    width: 100%;
    min-height: 40px;
    padding: 9px 23px;
    border: 1px solid #151514;
    border-radius: 3px;
    background: #fff;
    color: #151514;
    font-family: inherit;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.02em;
    cursor: pointer;
`;

export const DraftButton = styled(PublishButton)`
    background: #151514;
    color: #fff;
`;
import styled from 'styled-components';

export const ModalWrapper = styled.div`
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-height: calc(100vh - 80px);
    max-height: calc(100dvh - 80px);
    overflow-y: auto;
    padding: 16px 16px 40px;
    border-radius: 8px 8px 0 0;
    background: #fff;
    color: #151514;
    font-family: Inter, sans-serif;
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const ModalText = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
`;

export const Title = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;

export const Subtitle = styled.div`
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: -0.02em;
`;

export const CloseButton = styled.button`
    display: flex;
    flex: 0 0 24px;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
`;

export const ModalButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const PublishButton = styled.button`
    box-sizing: border-box;
    width: 100%;
    min-height: 40px;
    padding: 9px 23px;
    border: 1px solid #151514;
    border-radius: 3px;
    background: #fff;
    color: #151514;
    font-family: inherit;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.02em;
    cursor: pointer;
`;

export const DraftButton = styled(PublishButton)`
    background: #151514;
    color: #fff;
`;
